import provider from '@/api/apollo-client';
import { ref } from '@vue/composition-api';
import gqlItem from './item.graphql';
import gqlList from './list.graphql';

const item = ref({});
const saving = ref(false);
const list = ref([]);
const loading = ref(false);

function loadGroup(id) {
  loading.value = true;
  return provider
    .query({
      query: gqlList.loadGroups,
      variables: {
        filter: {
          id: { equalTo: id }
        }
      },
      fetchPolicy: 'no-cache'
    })
    .then(r => {
      const result = r.data.userGroups.find(i => i.id === id);
      if (result) {
        item.value = { ...result };
      } else {
        item.value = {};
      }
      return result || item.value;
    })
    .finally(() => {
      loading.value = false;
    });
}

function deleteUserFromGroup(data) {
  return provider.mutate({
    mutation: gqlItem.deleteUsersGroup,
    variables: {
      input: {
        id: data.id
      }
    },
    fetchPolicy: 'no-cache'
  });
}

function loadGroups() {
  loading.value = true;
  return provider
    .query({
      query: gqlList.loadGroups,
      fetchPolicy: 'no-cache'
    })
    .then(r => {
      list.value = r.data.userGroups.map(i => ({
        ...i,
        name: i.groupName
      }));
      return list.value;
    })
    .finally(() => {
      loading.value = false;
    });
}

function createGroup(data) {
  saving.value = true;
  return provider
    .mutate({
      mutation: gqlList.saveGroup,
      variables: {
        input: { userGroup: data }
      }
    })
    .then(r => {
      return {
        ...r.data.createUserGroup.userGroup,
        name: r.data.createUserGroup.userGroup.groupName
      };
    })
    .finally(() => {
      saving.value = false;
    });
}

function updateGroup(data) {
  saving.value = true;
  return provider
    .mutate({
      mutation: gqlList.updateGroup,
      variables: {
        input: data
      }
    })
    .then(() => {
      return loadGroups();
    })
    .finally(() => {
      saving.value = false;
    });
}

function addToGroup(data) {
  saving.value = true;
  return provider
    .mutate({
      mutation: gqlList.addToGroup,
      variables: {
        input: { usersToGroup: data }
      }
    })
    .finally(() => {
      saving.value = false;
    });
}

function removeGroup(id) {
  saving.value = true;
  return provider
    .mutate({
      mutation: gqlItem.removeGroup,
      variables: {
        input: { id }
      }
    })
    .finally(() => {
      saving.value = false;
    });
}

export default {
  group: {
    item,
    saving,
    loading,
    save: updateGroup,
    load: loadGroup,
    remove: removeGroup
  },
  groups: {
    list,
    saving,
    loading,
    save: createGroup,
    load: loadGroups,
    remove: deleteUserFromGroup,
    addToGroup
  }
};
